import React from "react";
import styles from "./SliderButton.module.scss";

const SliderButton = (props) => {
  if (props.hidden) return null;

  const onGoTo = (dir) => {
    props.slider?.current?.slider?.goTo(dir);
  };
  const imgSource = props.direction === "next" ? "./img/slide-arrow-next.svg" : "./img/slide-arrow-prev.svg";

  return (
    <div
      className={[
        styles.button,
        styles[props.direction],
        styles[props.color],
        props.compact ? styles.compact : "",
      ].join(" ")}
      onClick={() => onGoTo(props.direction.substring(0, 4))}
    >
      <div className={styles.imageContainer}>
        <img src={imgSource} className={styles[props.direction]} alt={props.direction} />
      </div>
    </div>
  );
};

const SliderControls = (props) => {
  return (
    <div className={["sliderControls", props.additionalClass].filter(Boolean).join(" ")}>
      <SliderButton
        direction="previous"
        slider={props.slider}
        color={props.color}
        hidden={props.isFirst}
        compact={props.compact}
      />
      <SliderButton
        direction="next"
        slider={props.slider}
        color={props.color}
        hidden={props.isLast}
        compact={props.compact}
      />
    </div>
  );
};

export { SliderButton };
export default SliderControls;
